//
// Action types
//

export const SET_PLATFORM_TITLE = "SET_PLATFORM_TITLE";

//
// Action creators
//

export function setPlatformTitle(title) {
  return {
    type: SET_PLATFORM_TITLE,
    title
  };
}

function setPlatformTitleHandler(state, title) {
  return { ...state, title };
}

//
// Reducer and handlers
//
export default function platformReducer(state, action) {
  switch (action && action.type) {
    case SET_PLATFORM_TITLE:
      return setPlatformTitleHandler(state, action.title);

    default:
      return state || {};
  }
}
